import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';

const atTop = el => el.scrollTop <= 0;
const atBottom = el => Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight;

const Wrapper = styled.div`
  height: 100vh;
  padding-bottom: 50px;
  overflow-y: auto;
  overscroll-behavior: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
`;

@observer
class ScrollTarget extends React.Component {

  componentDidMount() {
    // Attach event listeners after DOM is ready
    setTimeout(() => this.attachEventListeners(), 0);
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  attachEventListeners() {
    const zone = document.body;
    if (!zone) {
      setTimeout(() => this.attachEventListeners(), 100);
      return;
    }
    zone.addEventListener('wheel', this.handleWheel, { passive: false });
  }

  removeEventListeners() {
    const zone = document.body;
    if (!zone) return;
    zone.removeEventListener('wheel', this.handleWheel);
  }

  handleWheel = event => {
    const target = document.getElementById('scrollTarget');
    const app = document.querySelector('.app');
    const secondaryTarget = document.getElementById(this.props.secondaryTargetId);
    if (!target || !app || !secondaryTarget) return;

    const dy = event.deltaY;
    const goingDown = dy > 0;
    const goingUp = !goingDown;

    if (goingUp) {
      if (!atTop(app)) return;
      if (atTop(target)) return;
    }

    if (goingDown) {
      if (atBottom(target)) return;
      const secondaryTargetRect = secondaryTarget.getBoundingClientRect();
      const secondaryTargetNeedsScroll = secondaryTargetRect.bottom > window.innerHeight;
      if (secondaryTargetNeedsScroll) return;
    }

    event.preventDefault();
    target.scrollBy({ top: dy, behavior: 'auto' });
  };

  render() {
    return (
      <Wrapper id='scrollTarget'>
        {this.props.children}
      </Wrapper>
    );
  }
}

export default ScrollTarget;